import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Image from "next/image";
import Link from "next/link";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { BOOKS_LANDING, EBOOKS_LANDING, EBOOKS_UNIVERSITY_LANDING } from "@/settings/constant";
import { Divider, Typography } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { getAdBanner } from "src/api/adBanner";
import { useSideCategoryMenuStore } from "../SideSheets/store/useCategoryMenuStore";
import Icon from "../icon/Icon";
import { ArrowRight, GoodnoteIcon, Sizes } from "../icon/IconList";
import useCategoryPanelData from "./hooks/useCategoryPanelData";
import useCloseHandler from "./hooks/useCloseHandler";
import { AdStack, Box, BoxColumn, BoxContainer, BoxTitle, ButtonBox, CategoryBox, CategoryContainer, Label, LabelBox, MenuAdBox, MenuLinkBox, RowContainer, TwoColumnBox } from "./index.style";
export const MenuColumn = (param)=>{
    let { data , onColumnClick , isActive , suffix  } = param;
    return /*#__PURE__*/ _jsx(BoxColumn, {
        onClick: onColumnClick,
        className: isActive ? "active" : "",
        children: /*#__PURE__*/ _jsx(LabelBox, {
            children: /*#__PURE__*/ _jsxs(Label, {
                children: [
                    "name" in data ? data.name : data.title,
                    suffix && /*#__PURE__*/ _jsx(Icon, {
                        icon: ArrowRight,
                        size: Sizes.small
                    })
                ]
            })
        })
    });
};
const CategoryMenu = (param)=>{
    let { onClose  } = param;
    useCloseHandler();
    const { closeSideMenu  } = useSideCategoryMenuStore();
    const { data: menuAd  } = useQuery([
        "menupanAd"
    ], ()=>getAdBanner({
            position: "globalMenu"
        }), {
        retry: 3
    });
    const { oneDepthId , setOneDepthId , twoDepthId , setTwoDepthId , threeDepthId , setThreeDepthId , depthData  } = useCategoryPanelData();
    //카테고리 닫아주기 위한 이벤트
    const linkIsNewTab = (link)=>{
        return link.includes("https://solvook.com");
    };
    const categoryMenuMixpanel = (depth, title, url)=>{
        mixpanelEvent("Category Menu Clicked", {
            Depth: depth,
            "Menu Name": title,
            Url: url
        });
    };
    const categoryButtonMixpanel = (type, name, url)=>{
        mixpanelEvent("Category Button Clicked", {
            "Button Type": type,
            "Menu Name": name,
            Url: url
        });
    };
    if (!depthData.origin) return null;
    return /*#__PURE__*/ _jsxs(CategoryContainer, {
        onClick: (e)=>{
            if (e.target === e.currentTarget) onClose();
        },
        children: [
            /*#__PURE__*/ _jsxs(CategoryBox, {
                children: [
                    /*#__PURE__*/ _jsxs(MenuLinkBox, {
                        className: "depth-one-big-width",
                        children: [
                            /*#__PURE__*/ _jsx(BoxTitle, {
                                children: "과목"
                            }),
                            /*#__PURE__*/ _jsxs(RowContainer, {
                                children: [
                                    /*#__PURE__*/ _jsx(BoxContainer, {
                                        children: depthData.origin.depthItems.map((menu)=>/*#__PURE__*/ _jsx(MenuColumn, {
                                                data: menu,
                                                onColumnClick: ()=>{
                                                    categoryMenuMixpanel("one", menu.name, "");
                                                    setOneDepthId(menu.id);
                                                },
                                                isActive: oneDepthId === menu.id
                                            }, menu.id))
                                    }),
                                    /*#__PURE__*/ _jsxs(Box, {
                                        children: [
                                            /*#__PURE__*/ _jsxs(ButtonBox, {
                                                className: "active",
                                                children: [
                                                    /*#__PURE__*/ _jsxs(Typography, {
                                                        variant: "subtitle2",
                                                        sx: {
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            gap: "4px",
                                                            alignItems: "center",
                                                            marginBottom: "8px"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ _jsx(Icon, {
                                                                icon: GoodnoteIcon,
                                                                size: Sizes.small
                                                            }),
                                                            "굿노트6 eBook"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx(Link, {
                                                        href: EBOOKS_UNIVERSITY_LANDING,
                                                        onClick: ()=>categoryButtonMixpanel("goodnotes", "대학교재", EBOOKS_UNIVERSITY_LANDING),
                                                        children: /*#__PURE__*/ _jsx("button", {
                                                            children: "대학 교재"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx(ButtonBox, {
                                                children: /*#__PURE__*/ _jsx(Link, {
                                                    href: EBOOKS_LANDING,
                                                    onClick: ()=>categoryButtonMixpanel("goodnotes", "중고등 교재", EBOOKS_LANDING),
                                                    children: /*#__PURE__*/ _jsx("button", {
                                                        children: "중고등 교재"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(Divider, {}),
                                            /*#__PURE__*/ _jsx(ButtonBox, {
                                                children: /*#__PURE__*/ _jsx(Link, {
                                                    href: BOOKS_LANDING,
                                                    onClick: ()=>categoryButtonMixpanel("books", "배송 도서", BOOKS_LANDING),
                                                    children: /*#__PURE__*/ _jsx("button", {
                                                        children: "배송 도서"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    depthData.two && /*#__PURE__*/ _jsxs(MenuLinkBox, {
                        className: "depth-one-big-width",
                        children: [
                            /*#__PURE__*/ _jsx(BoxTitle, {
                                children: depthData.two.name
                            }),
                            /*#__PURE__*/ _jsx(RowContainer, {
                                children: /*#__PURE__*/ _jsx(BoxContainer, {
                                    children: depthData.two.items.map((menu, idx)=>/*#__PURE__*/ _jsx(MenuColumn, {
                                            data: menu,
                                            onColumnClick: ()=>{
                                                categoryMenuMixpanel("two", menu.name, "");
                                                setTwoDepthId(menu.id);
                                            },
                                            isActive: twoDepthId === menu.id
                                        }, menu.id))
                                })
                            })
                        ]
                    }),
                    depthData.three && /*#__PURE__*/ _jsxs(MenuLinkBox, {
                        className: "depth-one-big-width",
                        children: [
                            /*#__PURE__*/ _jsx(BoxTitle, {
                                children: /*#__PURE__*/ _jsxs(Link, {
                                    href: "/categories?id=".concat(depthData.three.id),
                                    onClick: ()=>categoryMenuMixpanel("three", depthData.three.name, ""),
                                    children: [
                                        depthData.three.name,
                                        /*#__PURE__*/ _jsx(Icon, {
                                            icon: ArrowRight,
                                            size: Sizes.smallHalf
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(RowContainer, {
                                children: /*#__PURE__*/ _jsx(BoxContainer, {
                                    children: depthData.three.items.map((menu, idx)=>/*#__PURE__*/ _jsx(MenuColumn, {
                                            data: menu,
                                            onColumnClick: ()=>{
                                                categoryMenuMixpanel("tree", menu.name, "");
                                                setThreeDepthId(menu.id);
                                            },
                                            isActive: threeDepthId === menu.id
                                        }, menu.id))
                                })
                            })
                        ]
                    }),
                    depthData.four && /*#__PURE__*/ _jsxs(MenuLinkBox, {
                        className: "depth-one-big-width",
                        children: [
                            /*#__PURE__*/ _jsx(BoxTitle, {
                                children: /*#__PURE__*/ _jsxs(Link, {
                                    href: "/categories?id=".concat(depthData.four.id),
                                    onClick: ()=>categoryMenuMixpanel("four", depthData.four.name, "/categories?id=".concat(depthData.four.id)),
                                    children: [
                                        depthData.four.name,
                                        /*#__PURE__*/ _jsx(Icon, {
                                            icon: ArrowRight,
                                            size: Sizes.smallHalf
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(RowContainer, {
                                children: /*#__PURE__*/ _jsx(TwoColumnBox, {
                                    children: depthData.four.items.map((menu, idx)=>/*#__PURE__*/ _jsx(Link, {
                                            href: "/categories?id=".concat(menu.id),
                                            onClick: closeSideMenu,
                                            children: /*#__PURE__*/ _jsx(MenuColumn, {
                                                data: menu,
                                                onColumnClick: ()=>{
                                                    categoryMenuMixpanel("tree", menu.name, "/categories?id=".concat(menu.id));
                                                },
                                                isActive: threeDepthId === menu.id
                                            }, menu.id)
                                        }, menu.id))
                                })
                            })
                        ]
                    })
                ]
            }),
            menuAd && /*#__PURE__*/ _jsx(MenuAdBox, {
                children: menuAd.items.map((ad, idx)=>/*#__PURE__*/ _jsx(AdStack, {
                        children: /*#__PURE__*/ _jsx(Link, {
                            href: ad.link,
                            target: linkIsNewTab(ad.link) ? "_self" : "_blank",
                            onClick: ()=>{
                                mixpanelEvent("AD Banner Clicked", {
                                    //mx-18 메뉴판 광고 버튼 클릭 시
                                    ID: ad.id,
                                    "Button URL": ad.link,
                                    Position: "globalMenu"
                                });
                            },
                            children: /*#__PURE__*/ _jsx(Image, {
                                width: 316,
                                src: ad.imageUrl,
                                height: 80,
                                alt: "ad banner image"
                            })
                        })
                    }, idx))
            })
        ]
    });
};
export default CategoryMenu;
